<!-- eslint-disable vue/require-explicit-emits -->
<template>
  <iRow
    :class="{
      ...classList,
      'empty-layout': isEmpty && !hasABorder,
      'root-layout': isRootLayout,
      'layout': true
    }"
    v-bind="{
      ...myLayoutProps,
      'data-identifier': identifier,
      'data-parent-id': identifier,
      'draggable': editMode && isDraggable(identifier, configuration) && !breakpoint
    }"
    v-on="myEventListeners"
  >
    <Teleport to="body">
      <DynamicComponentContextualMenu
        v-if="(isDynamicAppComponent ? true : canEditPublication)
          && showContextualMenu
          && contextMenuFixedPositionStyle.top
          && contextMenuFixedPositionStyle.left"
        v-bind="contextMenuAttrs"
        v-on="contextMenuEvents"
      />
    </Teleport>
    <div
      v-if="canResizeHorizontally && (mouseOver || selectedHoverBorder)"
      class="resize-handle left"
      @mousedown.stop="handleMouseDownResize($event, 'left')"
    />
    <div
      v-if="canResizeHorizontally && (mouseOver || selectedHoverBorder)"
      class="resize-handle right"
      @mousedown.stop="handleMouseDownResize($event, 'right')"
    />
    <div
      v-if="canResizeVertically && (mouseOver || selectedHoverBorder)"
      class="resize-handle top"
      @mousedown.stop="handleMouseDownResize($event, 'top')"
    />
    <div
      v-if="canResizeVertically && (mouseOver || selectedHoverBorder)"
      class="resize-handle bottom"
      @mousedown.stop="handleMouseDownResize($event, 'bottom')"
    />
    <slot />
  </iRow>
</template>

<script>
import { LayoutElementMixin } from "%/dynamic-components/render-engine/components/elements/layouts/layout-element-mixin";
import SpacingOptions from "%/dynamic-components/render-engine/bundles/spacing-options";
import BackgroundOptions from "%/dynamic-components/render-engine/bundles/background-options";
import HorizontalLayoutPositionOptions from "%/dynamic-components/render-engine/bundles/horizontal-layout-position-options";
import DynamicComponentContextualMenu from "%/dynamic-components/render-engine/components/DynamicComponentContextualMenu.vue";
import AppearanceOptions from "%/dynamic-components/render-engine/bundles/appearance-options";
import PositioningOptions from "%/dynamic-components/render-engine/bundles/positioning-options";
import AnimationOptions from "%/dynamic-components/render-engine/bundles/animations-options";
import EffectsOptions from "%/dynamic-components/render-engine/bundles/effects-options";
import AnimationEffectsOptions from "%/dynamic-components/render-engine/bundles/animation-effects-options";

export default {
  name: "HorizontalContainer",
  components: { DynamicComponentContextualMenu },
  mixins: [LayoutElementMixin],
  elementPanelSettings: {
    displayName: "Horizontal Container",
  },
  deprecated: true,
  optionBundles: [
    PositioningOptions,
    new HorizontalLayoutPositionOptions({
      "default.layout-direction": "horizontal",
      "default.layout-width": "fill",
      "default.layout-height": "hug",
    }),
    new AppearanceOptions({}, {
      "border-radius": false,
    }),
    AnimationOptions,
    AnimationEffectsOptions,
    new EffectsOptions({}, {
      "text-shadow": true,
    }),
    SpacingOptions,
    BackgroundOptions,
  ],
};
</script>
